import React from "react";
import CartHeading from "../../cart/CartHeading";
import { useAppSelector } from "../../../../configureStore";
import CartUpsell from "../../../../interfaces/cart/CartUpsell";
import PreUpsellItem from "./PreUpsellItem";

const PreUpsellList = () => {
    const upsells = useAppSelector((state) => state.upsells?.upsells);

    if (!upsells || upsells?.length === 0) {
        return null;
    }

    return (
        <>
            <CartHeading>Limited time offers</CartHeading>
            {upsells.map((upsell:CartUpsell) => <PreUpsellItem key={upsell.upsell_id} upsell={upsell} />)}
        </>
    );
};

export default PreUpsellList;
